import React from 'react';

import { productBrandNameApi } from 'api';
import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import { PO_SHIPPING_TYPE, PO_STATUS } from 'constants/purchaseOrder';

export const PURCHASE_ORDER_FILTER_OPTIONS = [
  {
    field: 'vendor__name__icontains',
    label: 'Vendor Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'brand',
    label: 'Brand',
    type: FILTER_TYPES.SEARCH,
    apiService: productBrandNameApi,
    valueField: 'id',
    searchField: 'name__icontains',
    renderItem: item => <div className="font-medium">{item.name}</div>,
  },
  {
    field: 'po_status',
    label: 'PO Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [...PO_STATUS],
  },
  {
    field: 'shipping_type',
    label: 'Shipping Type',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [...PO_SHIPPING_TYPE],
  },
  {
    field: 'expiration_date_after',
    label: 'Expiry Date After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'expiration_date_before',
    label: 'Expiry Date Before',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'contact_email__icontains',
    label: 'Email',
    type: FILTER_TYPES.TEXT,
  },
  { ...PAGE_SIZE_FILTER },
];

export const PURCHASE_ORDER_LINE_FILTER_OPTIONS = [
  {
    field: 'po_line_status',
    label: 'PO Line Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'processing', label: 'Processing' },
      { value: 'created', label: 'Created' },
      { value: 'completed', label: 'Completed' },
    ],
  },
  {
    field: 'vendor_product__product__sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'vendor_product__vendor_sku',
    label: 'Vendor SKU',
    type: FILTER_TYPES.TEXT,
  },
];
